export function PasswordRules({ value, rules }) {
  if (!value) return null;

  return (
    <ul className="mt-2 ml-4 list-none text-xs">
      {rules.map((rule, index) => {
        const isPassed = rule.test(value);
        const iconClasses = 'h-4 w-4';
        const textClasses = isPassed ? 'text-green-700' : 'text-red-700';

        return (
          <li key={index} className="flex items-center gap-2 mb-1">
            {isPassed ? (
              <svg
                className={`${iconClasses} text-green-500`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <svg
                className={`${iconClasses} text-coral-400`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            )}
            <span className={textClasses}>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
